module.exports = __webpack_public_path__ + "img/user.bc72fff2.svg";